import React, { useRef } from 'react';
import Icon from '../shared/Icon';
import LibraryDialog from '../Library/LibraryDialog';

/**
 * Add assessment with no usable scenario (PRD-1703, story 15): an assessment
 * runs against one, so the dialog says so and links to Add scenario in
 * Settings > Assessments. Coming back finds the form as it was left.
 */
function NoScenarios({ opener, fallbackFocus, onClose, onAddScenario }) {
  const cancelRef = useRef(null);
  return (
    <LibraryDialog title="Add assessment" size="wide" initialFocus={cancelRef} opener={opener} fallbackFocus={fallbackFocus} onClose={onClose}>
      <div className="library-empty assessment-dialog-empty">
        <Icon name="link" size={32} className="library-empty-icon" />
        <h3 className="library-empty-title">No scenarios yet</h3>
        <p className="library-empty-note">An assessment runs against a scenario. Create one from documents in the Library first.</p>
        <button type="button" className="resui-btn resui-btn--primary" onClick={onAddScenario}>Add scenario</button>
      </div>
      <div className="library-dialog-actions">
        <button ref={cancelRef} type="button" className="resui-btn resui-btn--secondary" onClick={onClose}>Cancel</button>
      </div>
    </LibraryDialog>
  );
}

export default NoScenarios;
